import styled from "styled-components";

export const Titulo = styled.h2`
margin-top: 40px;
text-align: center;
color: #EDC0C3;
`
export const Botoes = styled.div`
    @media (min-width: 900px) {
        display: flex;   
        column-gap: 30px;
    }
`